import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

export type ToggleOnboardingTaskInput = {
  partnerId: string;
  taskId: string;
  done: boolean;
};

// PATCH /api/partners/:id/onboarding/:taskId
//
// Worker fires onboarding_completed Slack ping via c.executionCtx.waitUntil
// when this toggle makes every task on the partner complete. No client
// concern beyond invalidating the keys.
export function useToggleOnboardingTask() {
  const queryClient = useQueryClient();
  return useMutation<{ ok: true }, ApiClientError, ToggleOnboardingTaskInput>({
    mutationFn: ({ partnerId, taskId, done }) =>
      apiFetch<{ ok: true }>(`/partners/${partnerId}/onboarding/${taskId}`, {
        method: "PATCH",
        body: JSON.stringify({ done }),
      }),
    onSuccess: (_data, { partnerId }) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.partners.onboarding(partnerId) });
      queryClient.invalidateQueries({ queryKey: queryKeys.partners.detail(partnerId) });
      // Sub-bucket 10 — admin overview aggregate (openTasks count).
      queryClient.invalidateQueries({ queryKey: queryKeys.admin.partners.overview(partnerId) });
    },
    onError: (err) => {
      toast.error(err.message ?? "Failed to toggle task");
    },
  });
}
